// import Login from "../components/auth/Login"
import LoginWrapper from "../components/auth/LoginWrapper"

const Authpage = () => {
    return <>
        {/* <Login />        */}
        <LoginWrapper />
    </>
}

export default Authpage